import React from 'react';
import { Typography } from 'antd';

const { Text } = Typography;

export function splitTaskHistoryDateTime(iso: string | null | undefined): {
  dateLine: string;
  timeLine: string;
} | null {
  if (!iso) return null;
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return null;
  const pad = (n: number) => String(n).padStart(2, '0');
  return {
    dateLine: `${pad(d.getDate())}.${pad(d.getMonth() + 1)}.${d.getFullYear()}`,
    timeLine: `${pad(d.getHours())}:${pad(d.getMinutes())}`
  };
}

export interface TaskHistoryCompletedAtCellProps {
  completedAt: string | null;
}

const TaskHistoryCompletedAtCell: React.FC<TaskHistoryCompletedAtCellProps> = ({ completedAt }) => {
  const parts = splitTaskHistoryDateTime(completedAt);
  if (!parts) {
    return <Text type="secondary">—</Text>;
  }

  return (
    <div style={{ minWidth: 0, lineHeight: 1.3 }} title={`${parts.dateLine} ${parts.timeLine}`}>
      <div>{parts.dateLine}</div>
      <Text type="secondary" style={{ fontSize: 11, display: 'block' }}>
        {parts.timeLine}
      </Text>
    </div>
  );
};

export default TaskHistoryCompletedAtCell;
